<div class="ui-g ui-fluid" style="position: relative">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title ui-g">
      <h1>Search Supplier</h1>
      <div class="ui-g-12" style="margin-left: 580px">
        <div style="float: left; width: 580px; margin-left: -580px">
          <form (ngSubmit)="search()" autocomplete="off">
            <div style="margin-right: 10px">
              <p-panel header="Pick-up Details">
                <div class="ui-g">
                  <div class="ui-g-12">
                    <div class="ui-grid-col-4">Location</div>
                    <div class="ui-grid-col-8">
                      {{ pickupLocation ? pickupLocation.primaryAddress : '' }}
                    </div>
                  </div>

                  <div class="ui-g-12">
                    <div class="ui-grid-col-4">
                      <label for="pickupDistance">Radius (miles)</label>
                    </div>
                    <div class="ui-grid-col-8">
                      <p-spinner
                        size="30"
                        [min]="0"
                        [max]="10000"
                        name="fromRadius"
                        [(ngModel)]="pickupDistance"
                      ></p-spinner>
                    </div>
                  </div>

                  <div class="ui-g-12">
                    <div class="ui-grid-col-4"><label for="supplierName">Supplier Name</label></div>
                    <div class="ui-grid-col-8">
                      <input
                        pInputText
                        name="supplierName"
                        [(ngModel)]="searchCriteria.supplierName"
                        maxlength="35"
                      />
                    </div>
                  </div>
                </div>
              </p-panel>
            </div>
          </form>
        </div>
        <div style="float: right; width: 100%">
          <map-control
            [height]="355"
            [(origin)]="pickupLocation"
            [(destination)]="dropoffLocation"
            [radiusPoints]="locationPoins"
            [(organisations)]="items"
          >
          </map-control>
        </div>
        <div style="clear: both"></div>
      </div>
      <div class="ui-g-12">
        <button
          type="button"
          (click)="close()"
          pButton
          icon="fa ui-icon-close"
          label="Back"
          class="ui-button btn-to-right"
        ></button>
        <button
          type="submit"
          pButton
          icon="fa ui-icon-check"
          label="Search"
          (click)="search()"
          class="ui-button green-btn btn-to-right"
          [disabled]="pickupLocation == null || dropoffLocation == null"
        ></button>
      </div>
    </div>
    <div>
      <p-table
        id="dtResult"
        selectionMode="single"
        [value]="items"
        [rows]="10"
        [responsive]="true"
        [paginator]="false"
        rowHover="true"
        [lazy]="false"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="3"
        resizableColumns="true"
        [(selection)]="selectedJob"
      >
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="name">Supplier Name</th>
            <th>Supplier Address</th>
            <th>Supplier Contact Details</th>
            <th pSortableColumn="distanceToPickup">Mileage to Pickup Location</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr>
            <td>{{ item.name }}</td>
            <td>
              <div>{{ addressStr(item) }}</div>
            </td>
            <td>
              <div>{{ contactStr(item) }}</div>
            </td>
            <td>{{ item.distanceToPickup }}</td>
          </tr>
        </ng-template>
      </p-table>

      <!-- DATATABLE DEPRECATED --
            <p-dataTabl id="dtResult" selectionMode="single" [value]="items" [rows]="10" [responsive]="true" [paginator]="false" rowHover="true"
                         [lazy]="false" [rowsPerPageOptions]="[5,10,20]" [pageLinks]="3"
                         resizableColumns="true" [(selection)]="selectedJob">

                <p-column field="name" header="Supplier Name" [sortable]="tru" [editable]="false" [style]="{'width': '20%'}"></p-column>
                <p-column field="" header="Supplier Address" [sortable]="tru" [editable]="false" [style]="{'width': '20%'}">
                    <ng-template pTemplate="body" let-item="rowData">
                        <div>{{ addressStr(item) }}</div>
                    </ng-template>
                </p-column>
                <p-column field="" header="Supplier Contact Details" [sortable]="tru" [editable]="false" [style]="{'width': '20%'}">
                    <ng-template pTemplate="body" let-item="rowData">
                        <div>{{ contactStr(item) }}</div>
                    </ng-template>
                </p-column>
                <p-column field="distanceToPickup" header="Mileage to pick – up location" [sortable]="tru" [editable]="false" [style]="{'width': '20%'}"></p-column>

            </p-dataTable>
            --->
    </div>

    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isBusy"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 15%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>
</div>
